import apiClient from './client'

/**
 * API per gestione clienti
 */

// Clienti
export const getClienti = (params) => apiClient.get('/customers/clienti/', { params })
export const getCliente = (id) => apiClient.get(`/customers/clienti/${id}/`)
export const createCliente = (data) => apiClient.post('/customers/clienti/', data)
export const updateCliente = (id, data) => apiClient.patch(`/customers/clienti/${id}/`, data)
export const deleteCliente = (id) => apiClient.delete(`/customers/clienti/${id}/`)
export const getStatisticheCliente = (id) => apiClient.get(`/customers/clienti/${id}/statistiche/`)
export const getStoricoOrdini = (id) => apiClient.get(`/customers/clienti/${id}/storico_ordini/`)

// Indirizzi
export const getIndirizzi = (params) => apiClient.get('/customers/indirizzi/', { params })
export const getIndirizzo = (id) => apiClient.get(`/customers/indirizzi/${id}/`)
export const createIndirizzo = (data) => apiClient.post('/customers/indirizzi/', data)
export const updateIndirizzo = (id, data) => apiClient.patch(`/customers/indirizzi/${id}/`, data)
export const deleteIndirizzo = (id) => apiClient.delete(`/customers/indirizzi/${id}/`)
